import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import store from '../../redux/stores/store'
import { AUTH_SAVE } from '../../redux/reducers/auth/action-types'
import Service from './require-login.sevice'

class RequireLogin extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
        this.interval = null;
    }

    componentDidMount() {
        let session = sessionStorage.getItem('auth')
        if (!session) {
            this.props.history.push('/auth/login?return=' + window.location.pathname)
            return
        }

        if (!store.getState().auth || !store.getState().auth.authorizationToken) {
            this.props.dispatch({
                type: AUTH_SAVE,
                payload: JSON.parse(session)
            })
        }

        this.setState({
            ...this.state,
            isLoggedIn: true
        })

        this.interval = setInterval(this.service.refreshToken, 1000 * 60 * 2);
    }

    componentWillUnmount(){
        if(this.interval !== null){
            clearInterval(this.interval)
        }
    }

    render() {
        return (
            <>
                {this.state.isLoggedIn && this.props.children}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(RequireLogin))